import React from 'react';
import { Card } from './ui/card';
import SwissHeadquarters from './impressum/SwissHeadquarters';
import GermanHeadquarters from './impressum/GermanHeadquarters';
import LegalSections from './impressum/LegalSections';

const Impressum = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-black via-black to-black min-h-screen pt-32">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Impressum
          </h1>

          <Card className="p-8 mb-8 bg-slate-800/40 backdrop-blur-xl border border-slate-700/50">
            <h2 className="text-2xl font-bold text-white mb-6">
              Angaben gemäß schweizerischem Recht
            </h2>

            <div className="space-y-8">
              <SwissHeadquarters />
              <GermanHeadquarters />
              <LegalSections />
            </div>
          </Card>

          <div className="text-center">
            <a
              href="/"
              className="inline-block text-blue-400 hover:text-blue-300 font-medium transition-colors"
            >
              &#8592; Zurück zur Startseite
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impressum;
